<template>
  <div class="new-promotion-series">
    <!-- 基础信息 -->
    <div class="panel" id="base">
      <div class="panel-title">基础信息</div>

      <!-- 手动推广 -->
      <template v-if="seriesParams.autoCampaignType != '1'">
        <!-- 广告类型 -->
        <div class="panel-row">
          <p class="panel-row-label">
            <span>广告类型</span>
            <span
              v-if="seriesError.promotionType && blur.name"
              class="panel-row-error"
            >
              <Icon class="panel-row-error-icon" type="md-close-circle"></Icon
              >请选择广告类型
            </span>
          </p>
          <Select
            v-model="seriesParams.promotionType"
            placeholder="请选择广告类型"
            @on-change="handlePromotionTypeChange"
          >
            <Option
              v-for="item in seriesTypeOptions"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <!-- 关联应用 -->
        <div class="panel-row" v-if="seriesParams.promotionType">
          <p class="panel-row-label">
            <span>关联{{ relatedAppOrWebText }}</span>
            <span v-if="seriesError.appId && blur.name" class="panel-row-error">
              <Icon class="panel-row-error-icon" type="md-close-circle"></Icon
              >请关联{{ relatedAppOrWebText }}
            </span>
          </p>
          <Select
            v-model="seriesParams.appId"
            :placeholder="`请关联${relatedAppOrWebText}`"
          >
            <Option
              v-for="item in relatedOptions"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <!-- 广告系列名称 -->
        <div class="panel-row">
          <p class="panel-row-label">
            <span>广告系列名称</span>
            <span v-if="seriesError.name && blur.name" class="panel-row-error">
              <Icon class="panel-row-error-icon" type="close-circled"></Icon
              >请输入100字以内的广告系列名称
            </span>
          </p>
          <Input
            v-model.trim="seriesParams.name"
            @on-blur="blur.name = true"
            placeholder="必填，限制字数100个字"
            :maxlength="100"
          />
        </div>
        <!-- 包名 -->
        <!-- <div class="panel-row">
                <p class="panel-row-label">包名</p>
                <Input v-model.trim="seriesParams.appBundle" :disabled="seriesParams.appBundleJY" placeholder="选填，限制字数100个字" :maxlength="100" />
            </div> -->
        <!-- 推广行业 -->
        <!-- <div class="panel-row">
                <p class="panel-row-label">
                    <span>行业</span>
                    <span v-if="seriesError.campaignType && blur.campaignType" class="panel-row-error">
                        <Icon class="panel-row-error-icon" type="close-circled"></Icon>请选择行业
                    </span>
                </p>
                <div class="dropdown-box">
                    <Dropdown trigger="click">
                        <Input v-model.trim="campaignTypeName" readonly style="width:5.48rem"/>
                        <DropdownMenu slot="list">
                            <Input class="dropdown-search" v-model="campaignTypeKeyword" placeholder="请输入关键字"/>
                            <div class="dropdown-group" v-for="group in filterCampaignTypeList" :key="group.level1Type">
                                <p class="dropdown-group-name">{{campaignTypeGroup[group.level1Type]}}</p>
                                <DropdownItem v-for="item in group.campaignSubTypes" :key="item.type" >
                                    <p @click="seriesParams.campaignType=item.type" class="dropdown-group-item">{{item.name}}</p>
                                </DropdownItem>
                            </div>
                            <div class="dropdown-group" v-if="!filterCampaignTypeList.length">
                                <p class="dropdown-group-name">没有匹配项</p>
                            </div>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div> -->
      </template>

      <!-- 自动推广 -->
      <template v-else>
        <!-- <div class="panel-row">
                <p class="panel-row-label">广告系列类型：自动</p>
            </div> -->
        <!-- 包名 -->
        <div class="panel-row">
          <p class="panel-row-label">包名：{{ seriesParams.appBundle }}</p>
        </div>
        <!-- 包名状态 -->
        <div class="panel-row">
          <p class="panel-row-label">
            包名状态：{{ seriesParams.offerBundleStatus ? "ON" : "OFF" }}
          </p>
        </div>
        <!-- 推广行业 -->
        <div class="panel-row">
          <p class="panel-row-label">行业：其他</p>
        </div>
        <!-- 广告系列名称 -->
        <div class="panel-row">
          <p class="panel-row-label">
            <span>广告系列名称</span>
            <span v-if="seriesError.name && blur.name" class="panel-row-error">
              <Icon class="panel-row-error-icon" type="close-circled"></Icon
              >请输入100字以内的广告系列名称
            </span>
          </p>
          <Input
            v-model.trim="seriesParams.name"
            @on-blur="blur.name = true"
            placeholder="必填，限制字数100个字"
            :maxlength="100"
          />
        </div>
      </template>
    </div>

    <!-- 投放信息 -->
    <div class="panel" id="ad">
      <div class="panel-title">投放信息</div>
      <!-- 落地页链接 -->
      <!-- <div v-if="seriesParams.autoCampaignType!='1'" class="panel-row">
            <div class="panel-row-label macro">
                <p>
                    <span>落地页链接</span>
                    <span v-if="seriesError.clickUrl && blur.clickUrl" class="panel-row-error">
                        <Icon class="panel-row-error-icon" type="close-circled"></Icon>请输入落地页
                    </span>
                </p>
                <p>
                    <span>添加</span>
                    <i @click="show.macroParams=true" class="btn-blue">宏参数</i>
                    <span>并配置</span>
                    <i @click="show.callbackLink=true" class="btn-blue">安装回调</i>
                    <span>、</span>
                    <i @click="show.installLink=true" class="btn-blue">事件回调</i>
                </p>
            </div>
            <Input v-model.trim="seriesParams.clickUrl" @on-blur="blur.clickUrl=true" placeholder="必填" />
        </div> -->
      <!-- 每日预算 -->
      <div class="panel-row">
        <p class="panel-row-label">
          <span>日预算</span>
          <span v-if="seriesError.dailyBudget" class="panel-row-error">
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >日预算不能为0
          </span>
        </p>
        <Input
          v-model.trim="seriesParams.dailyBudgetValue"
          @on-keyup="(e) => mixinRegNum(e, 0)"
          @on-change="(e) => mixinRegNum(e, 0)"
          :maxlength="8"
          placeholder="选填，默认不限"
        >
          <Select
            v-model="seriesParams.dailyBudgetType"
            slot="prepend"
            style="line-height: 36px;width:80px;"
          >
            <Option value="dailyBudget">花费</Option>
            <Option value="dailyImp">展示</Option>
            <Option value="dailyClick">点击</Option>
          </Select>
          <span
            v-if="seriesParams.dailyBudgetType == 'dailyBudget'"
            slot="append"
            >美元</span
          >
          <span v-if="seriesParams.dailyBudgetType == 'dailyImp'" slot="append"
            >千次</span
          >
          <span
            v-if="seriesParams.dailyBudgetType == 'dailyClick'"
            slot="append"
            >次</span
          >
        </Input>
      </div>
      <!-- 总预算 -->
      <div class="panel-row">
        <p class="panel-row-label">
          <span>总预算</span>
          <span v-if="seriesError.totalBudget" class="panel-row-error">
            <Icon class="panel-row-error-icon" type="close-circled"></Icon
            >总预算不能为0
          </span>
        </p>
        <Input
          v-model.trim="seriesParams.totalBudget"
          @on-keyup="(e) => mixinRegNum(e, 0)"
          @on-change="(e) => mixinRegNum(e, 0)"
          icon="social-usd"
          placeholder="选填，默认不限"
          :maxlength="8"
        />
      </div>
      <!-- 频次 -->
      <div class="panel-row">
        <p class="panel-row-label">频次</p>
        <p class="panel-row-radio-group" style="margin-bottom:0.1rem;">
          <cRadio
            @click="$set(seriesParams, 'frequencyTarget', 1)"
            :status="seriesParams.frequencyTarget == 1"
            label="设备ID"
          />
          <cRadio
            @click="$set(seriesParams, 'frequencyTarget', 2)"
            :status="seriesParams.frequencyTarget == 2"
            label="IP"
          />
        </p>
        <Input
          v-model.trim="seriesParams.frequency"
          @on-keyup="(e) => mixinRegNum(e, 0)"
          @on-change="(e) => mixinRegNum(e, 0)"
          placeholder="选填，默认不限"
          :maxlength="10"
        >
          <div slot="prepend">
            <Select
              v-model="seriesParams.frequencyDimension"
              style="line-height: 36px;width:80px;"
            >
              <Option :value="1">展示</Option>
              <Option :value="2">点击</Option>
            </Select>
          </div>
          <Select
            v-model="seriesParams.frequencyType"
            slot="append"
            style="line-height: 36px;width:80px;"
          >
            <Option :value="1">次/每天</Option>
            <Option :value="2">次/每周</Option>
          </Select>
        </Input>
      </div>
      <!-- 日期 -->
      <div class="panel-row data-picker">
        <p class="panel-row-label">日期</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(seriesParams, 'dayType', 0)"
            :status="seriesParams.dayType == 0"
            label="长期"
          />
          <cRadio
            @click="$set(seriesParams, 'dayType', 1)"
            :status="seriesParams.dayType == 1"
            label="指定"
          />
        </p>
        <cDatePicker
          v-if="seriesParams.dayType"
          :startDay.sync="seriesParams.startDay"
          :endDay.sync="seriesParams.endDay"
          placement="bottom-start"
          style="margin-top:0.1rem"
          :defaultBtn="false"
        />
      </div>
      <!-- 广告系列状态 -->
      <div class="panel-row">
        <p class="panel-row-label">广告系列状态</p>
        <p class="panel-row-radio-group">
          <cRadio
            @click="$set(seriesParams, 'status', 1)"
            :status="seriesParams.status == 1"
            label="ON"
          />
          <cRadio
            @click="$set(seriesParams, 'status', 0)"
            :status="seriesParams.status == 0"
            label="OFF"
          />
        </p>
      </div>
    </div>

    <!-- 保存 -->
    <div class="panel panel-btn">
      <Button
        v-if="seriesParams.autoCampaignType != '1'"
        type="primary"
        size="large"
        @click="onNextStep"
        >新建广告组</Button
      >
      <Button
        type="primary"
        size="large"
        @click="onSave"
        style="margin-left:0.3rem;"
        >保存并关闭</Button
      >
    </div>

    <!-- 宏参数 && 回调链接 -->
    <Modal v-model="show.macroParams" title="宏参数" width="700">
      <div class="macro-table">
        <div class="macro-row">
          <div class="macro-item">宏参数</div>
          <div class="macro-item">说明</div>
          <div class="macro-item">备注</div>
          <div class="macro-item">操作</div>
        </div>
        <div v-for="(item, index) in macroList" :key="index" class="macro-row">
          <div class="macro-item">{{ item.param }}</div>
          <div class="macro-item">{{ item.introduce }}</div>
          <div class="macro-item">{{ item.type }}</div>
          <div
            class="macro-item"
            v-clipboard:copy="item.param"
            v-clipboard:success="onCopySuccess"
          >
            <span style="color:#169BD5;cursor:pointer">复制</span>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>

    <Modal v-model="show.callbackLink" title="安装回调">
      <p>{{ callbackLink }}</p>
      <div slot="footer">
        <Button type="text" size="large" @click="show.callbackLink = false"
          >取消</Button
        >
        <Button
          type="primary"
          size="large"
          v-clipboard:copy="callbackLink"
          v-clipboard:success="onCopySuccess"
          >Copy</Button
        >
      </div>
    </Modal>

    <Modal v-model="show.installLink" title="事件回调">
      <p>{{ installLink }}</p>
      <div slot="footer">
        <Button type="text" size="large" @click="show.installLink = false"
          >取消</Button
        >
        <Button
          type="primary"
          size="large"
          v-clipboard:copy="installLink"
          v-clipboard:success="onCopySuccess"
          >Copy</Button
        >
      </div>
    </Modal>
    <!-- 宏参数 && 回调链接 -->

    <!-- 宏参数 && 回调链接 -->
    <Modal v-model="show.macroParams2" title="宏参数">
      <div class="macro-table">
        <div class="macro-row">
          <div class="macro-item">宏参数</div>
          <div class="macro-item">说明</div>
          <div class="macro-item">备注</div>
          <div class="macro-item">操作</div>
        </div>
        <div v-for="(item, index) in macroList2" :key="index" class="macro-row">
          <div class="macro-item">{{ item.param }}</div>
          <div class="macro-item">{{ item.introduce }}</div>
          <div class="macro-item">{{ item.type }}</div>
          <div
            class="macro-item"
            v-clipboard:copy="item.param"
            v-clipboard:success="onCopySuccess"
          >
            <span style="color:#169BD5;cursor:pointer">复制</span>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 宏参数 && 回调链接 -->
  </div>
</template>
<script>
import mixins from "@/mixins/index";
import cRadio from "@/components/commons/cRadio.vue";
import cDatePicker from "@/components/commons/cDatePicker.vue";
export default {
  name: "Series",
  mixins: [mixins],
  components: { cRadio, cDatePicker },
  data() {
    return {
      blur: {
        name: false,
        campaignType: false,
        clickUrl: false,
      },
      campaignTypeKeyword: "",
      //宏参数列表
      macroList: [
        { param: "{aff_sub}", introduce: "点击ID", type: "必填" },
        { param: "{impression_id}", introduce: "展示ID", type: "选填" },
        { param: "{adv_id}", introduce: "IDFA/GAID", type: "选填" },
        { param: "{aid}", introduce: "Androidid", type: "选填" },
        { param: "{campaign_id}", introduce: "广告系列ID", type: "选填" },
        { param: "{ad_set_id}", introduce: "广告组ID", type: "选填" },
        { param: "{creative_id}", introduce: "广告ID", type: "选填" },
        { param: "{user_ip}", introduce: "用户IP", type: "选填" },
        { param: "{country}", introduce: "国家", type: "选填" },
        { param: "{category}", introduce: "媒体分类", type: "选填" },
        { param: "{device_os}", introduce: "设备类型", type: "选填" },
        { param: "{ad_position}", introduce: "广告位", type: "选填" },
        {
          param: "{domain}",
          introduce: "网站域名",
          type: "选填（仅供网站流量）",
        },
        {
          param: "{referrer}",
          introduce: "网站来路",
          type: "选填（仅供网站流量）",
        },
        { param: "{timestamp}", introduce: "设备类型", type: "选填" },
        { param: "{ua}", introduce: "User-Agent", type: "选填" },
        {
          param: "{developer_id}",
          introduce: "开发者ID",
          type: "选填（仅内部运营使用）",
        },
        {
          param: "{akid}",
          introduce: "产品ID",
          type: "选填（仅内部运营使用）",
        },
        {
          param: "{bundle_id}",
          introduce: "包名",
          type: "选填（仅供app流量）",
        },
      ],
      macroList2: [
        { param: "{aff_sub}", introduce: "点击ID", type: "必填" },
        { param: "{adv_id}", introduce: "IDFA/GAID", type: "选填" },
        { param: "{ad_position}", introduce: "广告位", type: "选填" },
        { param: "{ua}", introduce: "User-Agent", type: "选填" },
        {
          param: "{bundle_id}",
          introduce: "包名",
          type: "选填（仅供app流量）",
        },
      ],
      //回调链接
      // callbackLink: 'http://active.dsp.batmobi.net/call/v1/ad/callback?bck={clickid}&advertising_id={advertiserId}&android_id={android-id}',
      show: {
        macroParams: false,
        callbackLink: false,
        installLink: false,
        macroParams2: false,
      },
      campaignTypeGroup: {
        1: "APP",
        2: "电商",
      },
    };
  },
  computed: {
    callbackLink() {
      return `http://dspcallback.nmmobi.com/call/v1/ad/callback?advertising_id=${this.$store.state.userData.publisherId}&bck={clickid}`;
    },
    installLink() {
      return `http://dspcallback.nmmobi.com/call/v1/ad/eventback?advertising_id=${this.$store.state.userData.publisherId}&bck={clickid}&eventName={eventName}&eventValue={eventValue}`;
    },
    status() {
      return this.$store.state.newPromotion.status;
    },
    // 广告类型选项
    seriesTypeOptions() {
      return this.$store.state.newPromotion.seriesTypeOptions;
    },
    // 关联应用（网站）文本
    relatedAppOrWebText() {
      return this.seriesParams.promotionType === 1 ? "应用" : "网站";
    },
    // 关联应用（网站）选项
    relatedOptions() {
      return this.$store.state.newPromotion.relatedOptions;
    },
    seriesParams() {
      return this.$store.state.newPromotion.seriesParams;
    },
    seriesError() {
      return this.$store.getters.seriesError;
    },
    // //推广行业列表
    // campaignTypeList() {
    //     return this.$store.state.newPromotion.campaignTypeList;
    // },
    // campaignTypeName() {
    //     let name = '';
    //     this.campaignTypeList.forEach(item =>
    //         item.campaignSubTypes.forEach(cell => {
    //             if (cell.type == this.seriesParams.campaignType) name = cell.name;
    //         })
    //     );
    //     return name ? name : '请选择推广行业';
    // },
    // //关键字过滤后的推广行业列表
    // filterCampaignTypeList() {
    //     const campaignTypeList = JSON.parse(JSON.stringify(this.campaignTypeList));
    //     const keyword = this.campaignTypeKeyword.toUpperCase().trim();
    //     //触发dropdown的重定位
    //     return campaignTypeList.filter(item => {
    //         item.campaignSubTypes = item.campaignSubTypes.filter(cell => {
    //             return cell.name.toUpperCase().includes(keyword);
    //         });
    //         return item.campaignSubTypes.length > 0;
    //     });
    // },
  },
  created() {
    // this.getCampaignTypeList();
    if (this.status.action != "add")
      for (const key in this.blur) this.blur[key] = true;
  },
  mounted() {
    // // setTimeout(()=>{
    //     this.$nextTick(()=>{
    //         console.log('this.seriesParams.appBundle',this.$store.state.newPromotion.seriesParams,this.$store.state.newPromotion.seriesParams.appBundle != '')
    //         this.appBundleJY = (this.$store.state.newPromotion.seriesParams.appBundle != '') ? true : false
    //     })
    // // })
  },
  methods: {
    /**
     * @desc 获取推广行业
     */
    // async getCampaignTypeList() {
    //     if (!this.campaignTypeList.length) {
    //         const res = await this.$axios.get(this.$port.manager.getCampaignTypeList);
    //         this.$store.commit('campaignTypeList', res.data.campaignTypes || []);
    //     }
    // },
    /**
     * @desc 复制成功
     */
    onCopySuccess() {
      if (
        this.show.macroParams ||
        this.show.callbackLink ||
        this.show.installLink
      ) {
        this.show.macroParams = false;
        this.show.callbackLink = false;
        this.show.installLink = false;
        this.$Message.success({ content: "复制成功", duration: 1.5 });
      }
      if (this.show.macroParams2) {
        this.show.macroParams2 = false;
        this.$Message.success({ content: "复制成功", duration: 1.5 });
      }
    },
    /**
     * @desc 点击保存
     */
    onSave() {
      for (const key in this.blur) this.blur[key] = true;
      this.$emit("submit");
    },
    /**
     * @desc 点击nextStep
     */
    onNextStep() {
      for (const key in this.blur) this.blur[key] = true;
      this.$emit("next-step");
    },
    // 更改广告类型时
    handlePromotionTypeChange() {
      this.$store.commit("setRelatedAppId", '');
    },
    // 获取关联应用（网站）的选项
    async getRelatedOptions() {
      const params = {
        appType: this.seriesParams.promotionType,
        page: 1,
        pageSize: 1000,
      };
      const res = await this.$axios.get(
        this.$port.property.applicationManager.list,
        {
          params,
        }
      );
      const list =
        (res.data &&
          res.data.list &&
          res.data.list.map((item) => ({
            label: item.appName,
            value: item.id,
            appType: item.appType,
          }))) ||
        [];
      this.$store.commit("setRelatedOptions", list);
    },
  },
  watch: {
    "seriesParams.promotionType": {
      handler() {
        this.getRelatedOptions();
      },
    },
  },
};
</script>
<style lang="scss">
.new-promotion-series {
  .data-picker {
    position: relative;
    .ivu-input {
      font-size: 0.12rem;
    }
    .c-date-picker .ivu-date-picker .ivu-input-icon {
      background-position: -353px -120px;
    }
  }
  .dropdown-box {
    .ivu-select-dropdown {
      max-height: 3rem;
      overflow: auto;
      width: 5.48rem;
      .dropdown-search {
        padding: 0 0.1rem 0.1rem 0.1rem;
      }
      .dropdown-group {
        &-name {
          line-height: 0.36rem;
          padding: 0 0.15rem;
          font-size: 0.16rem;
          color: #999;
        }
        &-item {
          line-height: 0.3rem;
          font-size: 0.14rem;
          padding: 0 0.3rem;
        }
      }
      .ivu-dropdown-item {
        padding: 0;
      }
    }
  }
}
.macro-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e2e2e2;
  border-left: 1px solid #e2e2e2;
  .macro-row {
    display: flex;
    .macro-item {
      flex: 0 0 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 0.4rem;
      font-size: 0.12rem;
      border-bottom: 1px solid #e2e2e2;
      border-right: 1px solid #e2e2e2;
    }
  }
}
.btn-blue {
  color: #169bd5;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Series.vue